<template>
  <div style=" position:absolute; top:0; left:0; z-index:1000;">
    <vue-draggable-resizable id="moreModal"
                             style="position: fixed;bottom: 5%;right: 1%;"
                             :isResizable="true"
                             :w="70"
                             :h="70"
                             :z="1000"
                             :draggable="false"
                             @dragging="onDragging"
                             @dragstop="onDragStop"

    >

      <!--      v-if="showChat === false"-->
      <el-tooltip :value="showTooltip" :manual="true" effect="light" placement="left" style="z-index: 999"
                  popper-class="mydata-tip">
        <div slot="content" style="min-width:300px;margin-right: 2px">
          <div style="min-width: 250px;height: 1px;">&nbsp;</div>
          <p style="font-size: 16px; font-weight: bold;width: 100%;font-family:'Helvetica Neue'">
            {{ ts('We are here !')['We are here !'] }}</p>
          <p style="font-size: 13px; font-weight: normal;width: 100%;font-family:'Helvetica Neue'">
            {{ ts('How can we help you ?')['How can we help you ?'] }}</p>
          <br>
          <div style="display: flex;justify-content: space-between;min-width:250px">
            <el-button @click="()=>{this.showTooltip = false}" :style="{backgroundColor:'white',color:'gray'}" round>
              {{ ts('No Thanks')['No Thanks'] }}
            </el-button>

            <el-button :loading="!canClick" @click="onOpenChatWindow"
                       :style="{backgroundColor:site.secondaryColor,color:'white'}" round>
              {{ ts('SEND MESSAGE')['SEND MESSAGE'] }}
            </el-button>
          </div>
        </div>

        <div @click="onOpenChatWindow"
             :style="{marginRight:'5px',border:'solid 1px white',width: '100%',height: '100%',backgroundImage:'url('+site.pcWebsiteLogo+')',backgroundSize:'100%',borderRadius:'100%',backgroundRepeat:'no-repeat',backgroundColor:'#302C40' }">

          <el-badge :is-dot="true" class="badge" :hidden="!(conversationFlagList.length > 0 )"></el-badge>

        </div>
      </el-tooltip>
    </vue-draggable-resizable>

    <div class="dialogue-wrapper" v-show="showChat">
      <div class="dialogue-main" v-loading="uploadLoading" :element-loading-text="ts('文件上传中')['文件上传中']"
           element-loading-spinner="el-icon-loading">

        <div class="dialogue-header" v-show="showSearchChat === false"
             style="position: relative"
             :style="{width:'100%',zIndex:1500,display:'flex',textAlign:'center',justifyContent: 'space-between',alignItems: 'center',alignContent: 'center',backgroundColor:site.mainColor}">

          <div style="width:15%;text-align: left;align-content: center;border: #222131;position: absolute;top: 15px;left:10px">
            <i class="el-icon-back" style="color:white;font-size: 23px" v-if="toUserId!==''"
               @click="()=>{this.toUserId = '';this.getHotelData();}"></i>
          </div>

          <div class="" style="width: 100%">
            <!--                  <i class="dialogue-service-img">头像</i>-->

            <div class="">
              <div class="" style="font-size: 20px">Support</div>
              <p class="dialogue-service-detail">

              </p>
            </div>
          </div>

<!--          <div id="" class="" @click="" style="width: 15%;">-->
<!--            <el-dropdown trigger="click" @command="handleShowSearchChatCommand"-->
<!--                         style="z-index:1500;width:10%;text-align: center;align-content: center;margin-top: 2px;border: #222131"-->
<!--                         placement="bottom-end">-->
<!--            <span class="el-dropdown-link">-->
<!--              <i class="el-icon-s-operation" style="color:white;font-size: 23px"></i>-->
<!--            </span>-->
<!--              <el-dropdown-menu slot="dropdown">-->
<!--                <el-dropdown-item>Search Chat-->
<!--                </el-dropdown-item>-->
<!--              </el-dropdown-menu>-->
<!--            </el-dropdown>-->
<!--          </div>-->


        </div>
        <div id="dialogue_contain" class="dialogue-contain" :style="{padding:toUserId?'0px':'10px','overflow-y':toUserId?'hidden':'auto'}" >
          <template v-if="!toUserId">
            <el-skeleton :rows="4" animated :loading="loading"/>
            <p style="width: 100%;min-height: 30px" v-if="isSearchHotel && toUserId===''">

              <input :placeholder="ts('HOTEL SEARCH')['HOTEL SEARCH']" v-model="searchHotelInput" type="text"
                     style="min-height:30px;text-align:center;width: 85%;height: 100%;background-color: white"
                     class="search-hotel-input">
              </input>
              <el-button @click="getHotelData" slot="append" icon="el-icon-search"
                         :style="{height: '100%',minHeight:'30px',color:'white',width:'15%',fontSize:'16px',textAlign:'center',alignContent:'center',alignItems:'center',backgroundColor:site.secondaryColor}"></el-button>

            </p>
            <div v-for="(item, index) in allMsgArr" style="display: flex;flex-direction: column">
              <div
                  style="display: flex;justify-content: center;align-items: center;margin-top: 10px;color: grey;font-size: 6px"
                  v-if="(item.createTime - allMsgArr[index-1<0?0:index-1].createTime > 120000 || index === 0) && item.msgType !== 3">
                <div>
                  {{ item.createTime | format }}
                </div>
              </div>
              <div>
                <p :class="!item.mine?'dialogue-service-contain':'dialogue-customer-contain'"
                   style="display: flex;flex-direction: row;align-items: center;">

                <div
                    :style="(item.msgType!==3 && item.mine)?{display: 'flex',flexDirection: 'row-reverse'}:{display: 'flex',flexDirection: 'row'}">

                  <div style="width:50px;display: flex;flex-direction: column"
                       v-if="!item.mine && (item.msgType !=3)">
                    <div>
                      <el-avatar round :size="40" :src="hotelLogo" v-if="(hotelLogo!==null&&hotelLogo!=='')"></el-avatar>
                      <el-avatar round :size="40" icon="el-icon-user-solid" style="background-color: #8ECF56;"
                                 v-else></el-avatar>
                    </div>
                    <div
                        style="text-overflow:'ellipsis';display: flex;justify-content: flex-start;align-items: flex-start;font-size: 2px;white-space: nowrap;color: black;font-weight: bold">
                      <div>
                        <!--                    <div style="text-overflow:'ellipsis';">-->
                        <!--                      {{ hotelName }}-->
                        <!--                    </div>-->
                      </div>
                    </div>
                  </div>

                  <div style="width:50px;display: flex;flex-direction: column"
                       v-if="item.mine">
                    <div>

                      <el-avatar round :size="40" :src="item.avatar" v-if="item.avatar"

                      ></el-avatar>
                      <el-avatar round :size="40" icon="el-icon-user-solid" v-else></el-avatar>
                    </div>
                    <div
                        style="text-overflow:'ellipsis';display: flex;justify-content: flex-end;align-items: flex-start;white-space: nowrap;color: black;font-weight: bold">
                      <div>
                        <!--                    <div style="text-overflow:'ellipsis';width: 100%;font-size: 2px;">-->
                        <!--                      {{ userInfo.inner.realname }}-->
                        <!--                    </div>-->
                      </div>
                    </div>
                  </div>
                  <div style="width:50px;display: flex;flex-direction: column"
                       v-if="(item.msgType===3)">
                    <div>
                      <el-avatar round :size="40" :src="item.avatar"
                                 v-if="(item.avatar!==null && item.avatar !== '')"></el-avatar>
                      <el-avatar round :size="40" icon="el-icon-office-building" v-else

                                 style="background-color: #8ECF56;"></el-avatar>
                    </div>

                  </div>

                  <span
                      :style="(item.msgType!==3 && item.mine)?{border:'1px solid '+site.secondaryColor}:{}"
                      :class="item.msgType===3?' dialogue-hotel-text':(!item.mine?'dialogue-text dialogue-service-text':'dialogue-text dialogue-customer-text')">

                    <span v-if="!item.extend" name="msg">
                          <div style="color: grey;font-size: 8px; font-weight: lighter;text-align: right"
                               v-if="(item.mine)">{{ item.name }}</div>

                         <div style="color: grey;font-size: 8px; font-weight: lighter;" v-if="(!item.mine)">{{
                             hotelName
                           }}</div>

                      <div style="color: black;font-size: 14px; font-weight: lighter;text-align: right"
                           :id="item.fromUserId+'content'" v-if="item.mine" v-html="item.content "></div>
                        <div style="color: black;font-size: 14px; font-weight: lighter" :id="item.fromUserId+'content'"
                             v-if="!item.mine" v-html="item.content " class="chat-hotel-name"></div>

                    </span>
                     <el-badge v-if="item.msgType === 3" :is-dot="true" class="badge"
                               :hidden="!(conversationFlagList.filter((it)=>item.fromUserId === it).length > 0 )">
                      <span class="chat-hotel-name" v-if="item.msgType === 3" @click="selectHouse(item)">
                        <div style="color: #222131;font-size: 16px; font-weight: bold;">{{ item.username }}</div>
                        <div style="color: #999999;font-size: 12px; font-weight: lighter;"
                             :id="item.fromUserId+'content'">{{ item.content }}</div>
                      </span>

                     </el-badge>

                    <span v-if="item.extend" name="msg">
                            <div style="color: grey;font-size: 8px; font-weight: lighter;text-align: right"
                                 v-if="(item.mine)">{{ item.name }}</div>

                         <div style="color: grey;font-size: 8px; font-weight: lighter;" v-if="(!item.mine)">{{
                             item.name
                           }}</div>

                      <el-image
                          :src="item.extend.url"
                          fit="fill"
                          :preview-src-list="[item.extend.url]">
                      </el-image>
                      </span>
            </span>
                </div>
              </div>
            </div>

          </template>
          <template v-else>
            <iframe scrolling="no" :src="`${chatUrl}/online/chat?rsId=${toUserId}`" style="width: 100%;height: 100%"></iframe>
          </template>
        </div>
<!--        <div-->
<!--            style="width: 100%;min-height: 30px;height:40px;display: flex;vertical-align: center;align-items: center;text-align: center;background-color: white">-->
<!--          <el-dropdown trigger="click" @command="handleCommand"-->
<!--                       style="width:10%;text-align: center;align-content: center;margin-top: 2px;border: #222131"-->
<!--                       placement="top-start">-->
<!--            <span class="el-dropdown-link">-->
<!--              <i class="el-icon-plus" :style="{color: site.secondaryColor,fontSize: '18px'}"></i>-->
<!--            </span>-->
<!--            <el-dropdown-menu slot="dropdown">-->
<!--              <el-dropdown-item icon="el-icon-picture" :disabled="loading || toUserId===''">Gallery-->
<!--              </el-dropdown-item>-->
<!--            </el-dropdown-menu>-->
<!--          </el-dropdown>-->

<!--          <el-upload-->
<!--              ref="upload"-->
<!--              v-show="false"-->
<!--              :style="{zIndex:'1001',display:'none',width:'100%',textAlign: 'center',alignContent: 'center',marginTop:' 2px',border: '#222131',color:site.secondaryColor}"-->
<!--              class="upload-resource avatar-uploader"-->
<!--              slot="prepend"-->
<!--              :action=uploadUrl-->
<!--              :before-upload="beforeUpload"-->
<!--              :on-success="handlerUploadSuccess"-->
<!--              :on-error="handlerUploadError"-->
<!--              :show-file-list="false">-->
<!--          </el-upload>-->
<!--          <el-input-->
<!--              style="width: 75%;border-radius: 0px"-->
<!--              resize="none"-->
<!--              :disabled="loading || toUserId===''"-->
<!--              @keyup.enter.native="()=>{sendMsg()}"-->
<!--              v-model="form.response">-->
<!--          </el-input>-->
<!--          <el-button slot="append" icon="el-icon-caret-right"-->
<!--                     @click="sendMsg"-->
<!--                     :disabled="loading || toUserId===''"-->
<!--                     :style="{minHeight:'40px',width:'15%',textAlign: 'center',alignContent: 'center',fontSize:'27px',color:'white',backgroundColor:site.secondaryColor }">-->
<!--          </el-button>-->
<!--        </div>-->
      </div>
    </div>
    <!--    <div v-model="handleVisible" :footer="null" width="700px" wrapClassName="modalBody">-->
    <!--      <img :src="viewPictureSrc" class="largeImg"/>-->
    <!--    </div>-->
  </div>
</template>

<script>
import VueDraggableResizable from 'vue-draggable-resizable'
import {getAction, postAction} from '@/api/manage'
import {LanguagePackage} from '@/mixins/LanguagePackage'
import {mapState} from 'vuex'
import {USER_INFO} from '@/store/mutation-types'

export default {
  components: {VueDraggableResizable},
  mixins: [LanguagePackage],
  computed: {
    ...mapState(['site']),
  },
  data() {
    return {
      token: '',
      chatUser: {},
      focusChat: {},
      reconnectFlag: false,
      uploadLoading: false,
      showTooltip: true,
      searchHotelInput: '',
      isSearchHotel: false,
      num: 0,
      indexNum: 0,
      showSearchChat: false,
      searchChatInput: '',
      loading: true,
      uploadUrl: process.env.VUE_APP_API + "/sys/common/upload",
      queryHotelUrl: process.env.VUE_APP_API + "/pc/home/qryHouseResourcesByPC",
      showChat: false,
      canClick: false,
      clientX: 0,
      clientY: 800,
      iconImage: "url(" + require('@/assets/images/logo.jpg') + ")",
      returnUrl: true,
      pagination: false,
      conversationForm: [],
      conversationFlagList: [],
      customerServiceList: [],
      messageList: [],
      // allMsgArr: [{
      //   fromUserId: '',
      //   messageData: [{
      //     username: '',
      //     createTime: '',
      //     content: '',
      //     msgType: '',
      //     avatar: ''
      //   }]
      // }],
      allMsgArr: [],
      allMsgArrTemp: [],
      handleVisible: false,
      fileList: [],
      viewPictureSrc: '',
      toUserId: '',
      chatUrl:process.env.VUE_APP_CHAT_CLIENT,
      toUserName: '',
      ws: null,
      hotelName: '',
      hotelLogo: '',
      userInfo: {
        name: '',
        from: '',
        userId: '',
        avatar: '',
        inner: {
          visitor: false,
          realname: null
        }
      },
      form: {
        response: ''
      },
      //ws心跳包
      heartCheck: {
        that: this,
        timeout: 2000,
        timeoutObj: null,
        reset: function () {
          clearTimeout(this.timeoutObj);
          this.start();
        }, start: function () {
          this.timeoutObj = setTimeout(() => {
            this.that.ws.send('{"code":0}')
          }, this.timeout)
        }, ready() {
          this.that.ws.send('{"code":1}')
        }
      },
    }

  },
  watch: {
    allMsgArr: function (val) {
      if (val.length > 0) {
        this.refresh()
      }
    }
  },
  filters: {
    //格式化时间
    format(dateStr, pattern = '') {
      if (dateStr === null || dateStr === '') {
        return ''
      }
      let dt = new Date(dateStr)
      //   yyyy-mm-dd
      let y = dt.getFullYear()
      let m = dt.getMonth() + 1 >= 10 ? dt.getMonth() + 1 : `0${dt.getMonth() + 1}`
      let d = dt.getDate() >= 10 ? dt.getDate() : `0${dt.getDate()}`
      if (pattern.toLowerCase() == 'yyyy-mm-dd') {
        return `${y}-${m}-${d}`
      } else {
        let hh = dt.getHours() >= 10 ? dt.getHours() : `0${dt.getHours()}`
        let mm = dt.getMinutes() >= 10 ? dt.getMinutes() : `0${dt.getMinutes()}`
        let ss = dt.getSeconds() >= 10 ? dt.getSeconds() : `0${dt.getSeconds()}`
        return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
      }
    }
  },
  methods: {

    goLogin() {

      let token = this.$ls.get('Access-Token') || ''
      let id = localStorage.getItem('session_id');
      console.log('token',token);
      if(token){
        $.ajax({
          async: false,
          type: "get",
          url: process.env.VUE_APP_API + "/sys/checkLogin",
          dataType: 'json',
          contentType: 'application/json;charset=UTF-8',
          headers: {
            'X-Access-Token': token
          },
          crossDomain: true, // 启用跨域请求
          xhrFields: {
            withCredentials: true // 发送跨域请求时携带 Cookies
          },
          success: function (rs) {
          },error:function(){
            token = null;
          }
        });
      }


      this.token = token;

      let that = this;

      if (!token) {
        if (!id) {
          id = parseInt(Math.random() * 10000000000000) + '';
          localStorage.setItem("session_id", id);
        }
        getAction("/sys/fastLoginAndReg?id=" + id).then(rs => {
          if (rs.success) {
            this.token = rs.result.token;
            this.userInfo = rs.result.userInfo;
            $.ajax({
              async: false,
              type: "post",
              url: process.env.VUE_APP_CHAT_SEVER + "/regAndLogin",
              dataType: 'json',
              contentType: 'application/json;charset=UTF-8',
              data: JSON.stringify({
                username: rs.result.userInfo.id,
                token: rs.result.token,
              }),
              crossDomain: true, // 启用跨域请求
              xhrFields: {
                withCredentials: true // 发送跨域请求时携带 Cookies
              },
              success: function (rs) {
                if (rs.code == 200) {
                  that.chatUser = rs.userInfo;
                  that.connectChat();
                }
              }
            });
          }
        })
      } else {

        this.userInfo = this.$ls.get(USER_INFO);

        $.ajax({
          async: false,
          type: "post",
          url: process.env.VUE_APP_CHAT_SEVER + "/regAndLogin",
          dataType: 'json',
          contentType: 'application/json;charset=UTF-8',
          data: JSON.stringify({
            username:  this.userInfo.id,
            token: token,
          }),
          crossDomain: true, // 启用跨域请求
          xhrFields: {
            withCredentials: true // 发送跨域请求时携带 Cookies
          },
          success: function (rs) {
            if (rs.code == 200) {
              that.chatUser = rs.userInfo;
              that.connectChat();
            }
          }
        });
      }

    },
    // 获取ws地址
    getWsUrl() {

      let url = process.env.VUE_APP_J_IM_WEBSOCKET_URL + '?token=' + this.token;

      return url;

    },
    connectChat() {

      this.ws = new WebSocket(this.getWsUrl());
      this.ws.onopen = () => {
        console.log('open');
        this.canClick = true;
        this.heartCheck.ready()
        this.heartCheck.start()
        this.dealMsg()
        console.log("加载酒店列表")
        this.getHotelData();
      }

      this.ws.onclose = () => {
        console.log('close')
        this.reconnectFlag = false
        this.reconnect()
      }

      this.ws.onerror = () => {
        console.log('error')
        this.reconnectFlag = true
        this.reconnect()
      }
    },
    //处理ws返回的消息
    dealMsg() {
      this.ws.onmessage = async (e) => {
        this.heartCheck.reset()
        let newMessage = JSON.parse(e.data)
        if (newMessage.command !== 13)

          if (newMessage.code == 2) {

            this.ws.send(JSON.stringify({
              code: "3",
              message: {
                chatId: newMessage.message.chatId,
                timestamp: new Date().getTime(),
                type: "1",
                userId: this.chatUser.userId + ''
              }
            }));

            if(newMessage.message.fromId!= this.chatUser.userId){
              let rs = await postAction("/ruoyi/chat/translate",
                  {chatId:newMessage.message.chatId,messageId:newMessage.message.id,content:newMessage.message.content})
              if(rs.success){
                if(rs.result){
                  newMessage.message.content = rs.result;
                }
              }
            }

            if (newMessage.message.fromId != this.chatUser.userId && this.toUserId !='') {
              this.allMsgArr.push({
                fromUserId: newMessage.message.fromId,
                mine: newMessage.message.fromId == this.chatUser.userId,
                username: newMessage.message.name,
                createTime: newMessage.message.timestamp,
                content: newMessage.message.content,
                msgType: newMessage.message.messageType,
                extend: newMessage.message.extend,
                messageType: newMessage.message.messageType,
                avatar: newMessage.message.avatar
              })
            }

          }
        //用户上线
        if (newMessage.command === 6) {
          if (newMessage.code === 10007) {
            console.log('-用户上线(user:', newMessage.data, ')')
            if (this.userInfo.inner.visitor) {
              localStorage.setItem('temp_userId', newMessage.data.userId)
            }
            this.userInfo.userId = newMessage.data.userId
            this.userId = newMessage.data.userId
            // this.userInfo.userId = '1530918940765523970'
            // this.userId = '1530918940765523970'
            this.userInfo.name = newMessage.data.nick
            this.userInfo.avatar = newMessage.data.avatar
            let historyConversationList = newMessage.data.friends[0].users;
            this.customerServiceList = newMessage.data.friends[0].users;
            // for (let i = 0; i < historyConversationList.length; i++) {
            //   this.getHistoryMsg(historyConversationList[i].userId, 100)
            // }
            if (this.toUserId !== '') {
              // this.getHistoryMsg(this.toUserId, 200)
              // this.loading = false
            } else {
              console.log("加载酒店列表")
              this.getHotelData();
            }

            sessionStorage.setItem('userid', newMessage.data.id)
            sessionStorage.setItem('nick', newMessage.data.nick)
            console.log('用户Id:' + this.userId)
            // this.getOfflineHistoryMsg()
          }
        }
        // 用户加入群组
        if (newMessage.command === 8) {
          let user = newMessage.data.user
          console.log('------用户加入群组(user:', user, ')------')
          if (newMessage.data.group === this.groupId) {
            // console.log(JSON.stringify(newMessage))
            this.$store.commit('handleGroupId', newMessage.data.group)
            let index = this.groupUserIds.indexOf(user.id)
            if (index !== -1) {
              // this.$set(this.groupUserList, index, user)
            } else {
              this.groupUserIds.push(user.id)
              this.groupUserList.push(user)
            }
            this.$store.commit('handleUserList', this.groupUserList)
          }
        }
        //用户下线(退出群组通知)
        if (newMessage.command === 10) {
          let user = newMessage.data.user
          console.log('用户下线(user:', user, ')-')
          let index = this.groupUserIds.indexOf(user.id)
          if (index !== -1) {
            this.groupUserList.splice(index, 1)
            this.groupUserIds.splice(index, 1)
          }
          this.$store.commit('handleUserList', this.groupUserList)
          // console.log(JSON.stringify(newMessage))
        }

        // 一般聊天消息
        if (newMessage.command === 11) {
          console.log('接收到新消息' + newMessage)
          this.operationNewMessage(newMessage)
        }
        // 用户信息更新响应
        if (newMessage.command === 39) {
          console.log('---用户信息更新响应---')
          // console.log(JSON.stringify(newMessage.data))
          let index = this.groupUserIds.indexOf(newMessage.data.id)
          if (index !== -1) {
            this.$set(this.groupUserList, index, newMessage.data)
          } else {
            this.groupUserIds.push(newMessage.data.id)
            this.groupUserList.push(newMessage.data)
          }
          this.$store.commit('handleUserList', this.groupUserList)
        }
        //用户在线列表
        if (newMessage.command === 18) {
          console.log('------用户在线列表更新------')
          console.log(JSON.stringify(newMessage))
          if (newMessage.data !== undefined && newMessage.data.friends.length > 0) {
            this.groupUserList = newMessage.data.friends[0].users
            this.groupUserIds = []
            newMessage.data.friends[0].users.forEach((item) => {
              this.groupUserIds.push(item.id)
            })
            this.$store.commit('handleUserList', this.groupUserList)
          }

          // console.log('this.groupUserIds',this.groupUserIds)
          // console.log('this.groupUserList',JSON.stringify(this.groupUserList))
        }
      }
    },
    switchCustomerService(value) {
      console.log("switch Customer Service " + value.key)
    },
    handleChange(value) {
      value = getFileAccessHttpUrl(value);
      this.sendMsgToServer(this.toUserId, 1, value);
      console.debug(value);
      this.fileList = [];
    },
    //获取左侧用户列表
    getUserList() {
      const userPar = {
        cmd: 17,
        type: 2,
        userId: this.userId,
      }
      this.ws.send(JSON.stringify(userPar))
    },
    operationNewMessage(newMsg) {
      switch (newMsg.data.msgType) {
          //文本
        case 0 :
          this.putNewMessage(newMsg)
          break
          //图片
        case 1:
          this.putNewMessage(newMsg)
          break
          //视频
        case 3:
          break
          //音乐
        case 4:
          break
        default:
          break
      }
    },
    putNewMessage(newMsg) {
      let content = newMsg.data.content;
      getAction('/aws/translate', {text: content}).then((rs) => {
        if (rs.result) {
          let param = this.newMessageJson(newMsg.data.from, newMsg.data.to, newMsg.data.from, newMsg.data.createTime, rs.result.text, newMsg.data.msgType, (newMsg.data.from !== this.toUserId), '')
          if (this.toUserId !== null && this.toUserId !== '') {
            this.toUserId = newMsg.data.from;
            this.allMsgArr.push(param)
          }
          if (newMsg.data.from === this.toUserId) {
            this.messageList.push(param)
          } else {
            if (document.getElementById(param.fromUserId + 'content')) {
              document.getElementById(param.fromUserId + 'content').innerText = rs.result.text
            }

            if (this.conversationFlagList.indexOf(param.fromUserId) === -1) {
              this.conversationFlagList.push(param.fromUserId)
              this.$store.commit('updateConversationFlagList', this.conversationFlagList)
            }
          }

        }
      });

    },
    newMessageJson(fromUserId, toUserId, username, createTime, content, msgType, unread, avatar,mine,extend) {
      let param = {
        fromUserId: fromUserId,
        toUserId: toUserId,
        username: username,
        createTime: createTime,
        content: content,
        msgType: msgType,
        unread: unread,
        avatar: avatar,
        mine:mine,
        extend:extend
      }

      if (param.mine) {
        let paramTo = {
          fromUserId: toUserId,
          toUserId: fromUserId,
          username: toUserId,
          createTime: createTime,
          content: content,
          msgType: msgType,
          unread: unread,
          avatar: avatar
        }
        let flag = true;
        for (let index = 0; index < this.conversationForm.length; index++) {
          if (this.conversationForm[index].fromUserId === toUserId) {
            this.conversationForm.splice(index, 1)
            this.conversationForm.unshift(paramTo)
            flag = false;
            break;
          }
        }
        if (flag) {
          this.conversationForm.push(paramTo);
        }
      } else {
        let flag = true;
        for (let index = 0; index < this.conversationForm.length; index++) {
          if (this.conversationForm[index].fromUserId === fromUserId) {
            this.conversationForm.splice(index, 1)
            this.conversationForm.unshift(param)
            flag = false;
            break;
          }
        }
        if (flag) {
          this.conversationForm.push(param);
        }
      }
      return param;
    },
    putNewChat(newMsg) {

      console.log(this.allMsgArr);

      let param = this.newMessageJson(newMsg.fromId, newMsg.chatId, newMsg.fromId, new Date(), newMsg.content, newMsg.msgType, false, newMsg.avatar,newMsg.mine,newMsg.extend);
      // let paramTo = this.newMessageJson(newMsg.to,newMsg.from, newMsg.to,new Date(),newMsg.content,newMsg.msgType,false,'');

      console.log(this.allMsgArr);
      this.allMsgArr.push(param)
      this.messageList.push(param)
    },
    //获取离线消息记录
    getOfflineHistoryMsg() {
      if (this.start > this.allMsgArr.length - 1) {
        return false
      }
      const historyPar = {
        cmd: 19,
        userId: this.userInfo.userId,
        type: 0,
        offset: 0,
        count: 100
      }
      // console.log(JSON.stringify(historyPar))
      this.ws.send(JSON.stringify(historyPar))
      // this.offset += 30
    },
    //获取用户历史消息记录
    getHistoryMsg(fromUserId, count) {
      if (this.start > this.allMsgArr.length - 1) {
        return false
      }
      let that = this;
      $.ajax({
        async: false,
        type: "get",
        url: process.env.VUE_APP_CHAT_SEVER + `/api/sys/messages?chatId=${this.focusChat.id}&fromId=${this.chatUser.userId}&type=1&pageSize=100`,
        dataType: 'json',
        headers: {
          'Authorization': 'Bearer ' + this.token
        },
        crossDomain: true, // 启用跨域请求
        xhrFields: {
          withCredentials: true // 发送跨域请求时携带 Cookies
        },
        success: function (rs) {
          if (rs.code == 200) {
            rs.data.forEach(item => {
              let param = {
                fromUserId: item.fromId,
                mine: item.mine,
                username: item.name,
                createTime: item.timestamp,
                content: item.content,
                msgType: item.messageType,
                messageType: item.messageType,
                avatar: item.avatar,
                extend: item.extend
              }
              that.allMsgArr.push(param)
            })
          }
        }
      });
    },
    beforeUpload() {
      this.uploadLoading = true
    },
    handlerUploadSuccess(res, file) {
      this.uploadLoading = false

      if (res.code === 0) {
        this.sendMsgToServer(this.toUserId, 1, res.message);
      }

    },
    handlerUploadError() {
      this.uploadLoading = false
      this.$message({
        message: this.translate('上传失败'),
        type: 'error'
      });
    },
    sendMsg() {
      if (this.form.response.trim() === '') {
        return false
      }
      this.sendMsgToServer(this.toUserId, 0, this.form.response);
      this.form.response = ''
    },
    sendMsgToServer(toUserId, msgType, content) {
      let par;

      if (msgType == 1) {
        par = {
          messageType: msgType,
          msgType: msgType,
          chatId: this.focusChat.id,
          fromId: this.chatUser.userId,
          mine: true,
          tk:this.token,
          content: '',
          extend: {
            url: content
          },
          timestamp: new Date().getTime(),
          type: "1",
        };
      } else {
        par = {
          tk:this.token,
          messageType: msgType,
          msgType: msgType,
          chatId: this.focusChat.id,
          fromId: this.chatUser.userId,
          mine: true,
          content: content,
          timestamp: new Date().getTime(),
          type: "1",
        };
      }


      if (content.length !== 0) {
        console.log('发送消息--》' + JSON.stringify(par));
        this.ws.send(JSON.stringify({code: "2", message: par}))
        this.putNewChat(par);
        this.content = ''
      }
    },
    // 选择会话
    click(record, index) {
      return {
        on: {
          click: () => {
            for (let index = 0; index < this.conversationForm.length; index++) {
              if (this.conversationForm[index].fromUserId === record.fromUserId) {
                this.conversationForm[index].unread = false;
                break;
              }
            }
            this.selectChat(null, record, index)
          }
        }
      }
    },
    selectChat(text, record, index) {
      console.log(record)
      this.toUserName = record.fromUserId;
      this.toUserId = record.fromUserId;
      this.messageList = this.allMsgArr.filter(item => (item.fromUserId === this.toUserId || item.toUserId === this.toUserId))
    },
    // 查看大图
    viewPicture(content) {
      this.handleVisible = true
      this.viewPictureSrc = content
    },
    // 滚动条置底
    refresh() {
      this.$nextTick(() => {
        // this.midCard = this.$refs.midCard
        // console.log(this.midCard.scrollHeight)
        document.getElementById('dialogue_contain').scrollTop = document.getElementById('dialogue_contain').scrollHeight
        // console.log(document.getElementById('dialogue_contain').scrollTop)
        // console.log(document.getElementById('dialogue_contain').scrollHeight)
      })
    },
    onOpenChatWindow() {
      console.log('123123');
      if (this.getWsUrl() === '') {
        this.$router.push('/login')
        return;
      }
      if (this.canClick === true) {
        this.showChat = !this.showChat
      }

      if (this.allMsgArr.length > 0) {
        this.refresh()
      }
      this.showTooltip = false
    },
    getHotelData() {
      this.isSearchHotel = false;
      this.loading = true
      this.allMsgArr = []
      let param = {
        'realUserId': this.userInfo.userId,
        // 'userId': this.userInfo.userId,
        'userId': '1530918940765523970',
        'pageSize': 99
      }
      getAction(this.queryHotelUrl, param).then((res) => {
        if (res.code === 0) {
          if (res.result.length === 0) {
            this.$message({
              message: this.translate('客服未查询到酒店列表'),
              type: 'warning'
            });
          } else {
            for (var i = 0; i < res.result.length; i++) {
              let m = res.result[i]
              let param = {
                fromUserId: m.houseResourcesId,
                // toUserId: m.to,
                username: m.houseResourcesName,
                createTime: '',
                content: m.lastMessage,
                msgType: 3,
                unread: false,
                avatar: m.logoUrl
              }
              console.log(param.username.toString().indexOf(this.searchHotelInput))
              if (this.searchHotelInput !== '' && param.username.toString().indexOf(this.searchHotelInput) >= 0) {
                this.allMsgArr.push(param)
              } else if (this.searchHotelInput === '') {
                this.allMsgArr.push(param)
              }


            }
          }
        }


        this.searchHotelInput = ''
        this.isSearchHotel = true;
        this.loading = false
      })
    }, selectHouse(item) {
      this.allMsgArr = []
      this.toUserId = item.fromUserId
      this.hotelName = item.username
      this.hotelLogo = item.avatar

      let index = this.conversationFlagList.findIndex((item) => {
        if (item.fromUserId === item) {
          return true
        }
      })
      this.conversationFlagList.splice(index, 1)
      this.$store.commit('updateConversationFlagList', this.conversationFlagList)
      let that = this;
      $.ajax({
        async: false,
        type: "post",
        url: process.env.VUE_APP_CHAT_SEVER + "/api/sys/groups",
        dataType: 'json',
        headers: {
          'Authorization': 'Bearer ' + this.token
        },
        contentType: 'application/json;charset=UTF-8',
        data: JSON.stringify({
          avatar: "/img/default-group.png",
          needCheck: 0,
          name: 'hotel_chat',
          hotelId: this.toUserId
        }),
        crossDomain: true, // 启用跨域请求
        xhrFields: {
          withCredentials: true // 发送跨域请求时携带 Cookies
        },
        success: function (rs) {
          if (rs.code == 200) {
            that.focusChat = rs.data;
          }
        }
      });
      this.getHistoryMsg(this.toUserId, 200)
    },
    handleCommand(command) {
      document.querySelector(".upload-resource .el-upload").click()
    }, handleShowSearchChatCommand() {
      this.showSearchChat = true
    }, searchChatChange() {
      this.num = 0;
      this.indexNum = 0;
      let search = this.searchChatInput;
      if (this.allMsgArrTemp.length === 0) {
        this.allMsgArrTemp = this.allMsgArr
      }
      if (search === null || search === '') {
        console.log("搜索为空")
        this.allMsgArr = []
        this.allMsgArr = this.allMsgArrTemp
        this.allMsgArrTemp = [];
        for (let i = 0; i < this.allMsgArr.length; i++) {
          this.allMsgArr[i].content = this.allMsgArr[i].content.replaceAll("<font style=\"background-color:#8ECF56\">", "");
          this.allMsgArr[i].content = this.allMsgArr[i].content.replaceAll("</font>", "");
        }
      } else {
        console.log("搜索不为空")
        let flag = true;
        this.allMsgArr = []
        this.allMsgArr = this.allMsgArrTemp
        for (let i = 0; i < this.allMsgArr.length; i++) {
          this.allMsgArr[i].content = this.allMsgArr[i].content.replaceAll("<font style=\"background-color:#8ECF56\">", "");
          this.allMsgArr[i].content = this.allMsgArr[i].content.replaceAll("</font>", "");
          if (this.allMsgArr[i].content.indexOf(search) >= 0) {
            this.allMsgArr[i].content = "<font style=\"background-color:#8ECF56\">" + this.allMsgArr[i].content + "</font>"
            if (flag) {
              this.indexNum = i;
              this.num = i;
              document.getElementsByName('msg')[i].scrollIntoView()
            }

            flag = false
          }

        }
      }

    },
    windowScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      // console.log(scrollTop);

      if (document.documentElement.clientHeight < scrollTop) {
        this.clientY = scrollTop + 200;
      } else if (document.documentElement.clientHeight < scrollTop + 800) {
        this.clientY = scrollTop + document.documentElement.clientHeight - 200
      } else {
        this.clientY = scrollTop + 800
      }
    },
    // 下一个
    next() {

      let find = false;
      let indexNumTemp = this.indexNum
      if (this.allMsgArr.length !== 0) {
        if (this.indexNum === this.num - 1) {
          this.indexNum = 0
        } else {
          this.indexNum = this.indexNum + 1
        }
        for (let i = this.indexNum; i < this.allMsgArr.length; i++) {
          if (this.allMsgArr[i].content.indexOf(this.searchChatInput) >= 0) {
            this.indexNum = i;
            find = true
            break;
          }
        }
        if (!find) {
          this.indexNum = indexNumTemp
        }
        console.log(this.indexNum)
        document.getElementsByName('msg')[this.indexNum].scrollIntoView()
      }
    },
    // 上一个
    prev() {
      let find = false;
      let indexNumTemp = this.indexNum
      if (this.allMsgArr.length !== 0) {
        if (this.indexNum < 0) {
          this.indexNum = 0
        } else {
          this.indexNum = this.indexNum - 1 < 0 ? 0 : this.indexNum - 1
        }
        for (let i = this.indexNum; i >= 0; i--) {
          if (this.allMsgArr[i].content.indexOf(this.searchChatInput) >= 0) {
            this.indexNum = i;
            find = true
            break;
          }
        }
        if (!find) {
          this.indexNum = indexNumTemp
        }
        console.log(this.indexNum)
        document.getElementsByName('msg')[this.indexNum].scrollIntoView()
      }
    },
    getPersonInfo() {
      getAction(`/pc/home/qryPersonalInfo`).then((res) => {
        if (res.result && res.result.lastName) {
          this.userInfo.inner.realname = res.result.firstName + ' ' + res.result.lastName
        }
      })
    },
    onCloseChatWindow() {
      this.showChat = false
    }, onDragging() {
      this.canClick = false;
    }, onDragStop() {
      setTimeout(() => {
        this.canClick = true;
      }, 50)

    }, onDragCallback(x, y) {
      this.canClick = false;

    }, onDragStartCallback(ev) {
      this.canClick = false;
    }, reconnect() {
      if (this.reconnectFlag) {
        this.reconnectFlag = false
        setTimeout(() => {
          this.ws = new WebSocket(this.getWsUrl());
          this.ws.onopen = () => {
            console.log('reopen');
            this.canClick = true;
            this.heartCheck.start()
            this.dealMsg()
            this.getHotelData();
          }
          this.reconnectFlag = true
          this.ws.onclose = () => {
            console.log('close')
            this.reconnect()
          }

          this.ws.onerror = () => {
            console.log('error')
            this.reconnect()
          }
        }, 2000);


      }

    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.windowScroll)
  },
  mounted() {
    this.clientX = document.documentElement.clientWidth - 100;
    this.clientX = document.documentElement.clientWidth - 100;
    window.addEventListener('scroll', this.windowScroll);
    window.onresize = () => (() => {
      this.clientX = document.documentElement.clientWidth - 100;
      this.windowScroll()
    })();
  }, created() {
    // this.conversationFlagList = this.$store.state.conversationFlagList
    // this.ws = new WebSocket(this.getWsUrl());
    // this.ws.onopen = () => {
    //   console.log('open')
    //   this.heartCheck.start()
    //   this.dealMsg()
    //   if (this.toUserId !== '') {
    //     this.getHistoryMsg(this.toUserId, 200)
    //     this.loading = false
    //   }
    // }
    // setTimeout(()=>{this.showTooltip = true;this.canClick=true},2000)
    // this.ws.onclose = () => {
    //   console.log('close')
    //   this.reconnectFlag = true
    //   this.reconnect()
    // }
    //
    // this.ws.onerror = () => {
    //   console.log('error')
    //   this.reconnectFlag = true
    //   this.reconnect()
    // }

    this.goLogin();
  },

}
</script>

<style scoped>
ul {
  margin: 0;
  padding: 0;
  list-style: none;
  outline: none;
}

dl, dd {
  margin: 0;
}

a {
  display: inline-block;
  margin: 0;
  padding: 0;
  text-decoration: none;
  background: transparent;
  outline: none;
  color: #000;
}

a:link, a:visited, a:hover, a:active {
  text-decoration: none;
  color: currentColor;
}

a, dt, dd {
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: transparent;
}

img {
  border: 0;
}

p {
  margin: 0;
}

input, button, select, textarea {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  background-color: transparent;
}

/*css reset*/
body {
  position: relative;

}

.dialogue-wrapper {
  font-size: 14px;
  color: #fff;
  height: 100%;
}

/*右侧点击按钮*/
.dialogue-wrapper .dialogue-support-btn {
  border-radius: 1000px;
  position: fixed;
  display: inline-block;
  top: 50%;
  right: 0;
  margin-top: -70px;
  padding: 10px 0;
  width: 60px;
  height: 20px;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  cursor: pointer;
  box-shadow: -1px 1px 5px rgba(0, 0, 0, .4);
  background-color: #302C40;
}

.dialogue-wrapper .dialogue-support-btn .dialogue-support-icon {
  position: relative;
  display: inline-block;
  margin-bottom: -2px;
  width: 20px;
  height: 16px;
  border-radius: 4px;
  background-color: #fff;
}

.dialogue-wrapper .dialogue-support-btn .dialogue-support-icon:before {
  content: '';
  position: absolute;
  left: 50%;
  bottom: -6px;
  margin-left: -3px;
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 6px solid #fff;
}

.dialogue-wrapper .dialogue-support-btn .dialogue-support-line {
  display: inline-block;
  width: 100%;
  height: 1px;
  background-color: #ddd;
}

.dialogue-wrapper .dialogue-support-btn .dialogue-support-text {
  padding: 5px 0;
  letter-spacing: 4px;
  writing-mode: vertical-rl;
  -webkit-user-select: none;
}

/*底部客服对话框*/
.dialogue-wrapper .dialogue-main {
  position: fixed;
  display: inline-block;
  right: 6%;
  bottom: 10px;
  width: 400px;
  margin-right: 15px;
  /*height: 600px;*/
  border-radius: 4px;
  box-shadow: 0 0 5px rgba(0, 0, 0, .4);
}

/*客服对话框头部*/
.dialogue-wrapper .dialogue-main .dialogue-header {
  position: relative;
  padding: 10px;
  height: 60px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  box-shadow: 0 0 5px rgba(0, 0, 0, .2);
}

.dialogue-wrapper .dialogue-main .dialogue-close {
  position: absolute;
  top: 10px;
  right: 20px;
  padding: 2px;
  font-size: 25px;
  /*transform: rotate(90deg);*/
  cursor: pointer;
}

.dialogue-wrapper .dialogue-main .dialogue-left {
  position: absolute;
  top: 10px;
  left: 20px;
  padding: 2px;
  font-size: 25px;
  /*transform: rotate(90deg);*/
  cursor: pointer;
}

.dialogue-wrapper .dialogue-main .dialogue-service-info {
  position: relative;
  top: 50%;
  margin-top: -20px;
  height: 40px;
}

.dialogue-wrapper .dialogue-main .dialogue-service-img {
  display: inline-block;
  margin: 0 10px 0 20px;
  width: 40px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  vertical-align: middle;
  color: #000;
  border-radius: 50%;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, .2);
  background-color: #fff;
}

.dialogue-wrapper .dialogue-main .dialogue-service-back {
  display: inline-block;
  margin-left: 5px;
  text-align: center;
  width: 40px;
  height: 40px;
  text-align: center;
  vertical-align: middle;
  color: #000;
  border-radius: 50%;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, .2);
}

.dialogue-wrapper .dialogue-main .dialogue-service-title {
  vertical-align: middle;
  text-align: center;
}

.dialogue-wrapper .dialogue-main .dialogue-service-detail {
  font-size: 12px;
}

/*客服对话框内容*/
.dialogue-wrapper .dialogue-main .dialogue-contain {
  overflow-y: auto;
  padding: 10px;
  height: 600px;
  word-wrap: break-word;
  background-color: #e9f1f6;
}

.dialogue-wrapper .dialogue-main .dialogue-text {
  display: inline-block;
  position: relative;
  padding: 10px;
  max-width: 200px;
  height: auto;
  white-space: pre-wrap;
  border: 1px solid #8ECF56;
  border-radius: 4px;
  color: black;
  /*width: 100%;*/
  width: auto;
  background-color: white;
  box-sizing: border-box;
}

.dialogue-wrapper .dialogue-main .dialogue-service-contain {
  /*margin-bottom: 10px;*/
  margin-top: 10px;
  display: flex;
  vertical-align: center;
  align-items: center;
  align-content: center;
  text-align: left;
}

.dialogue-wrapper .dialogue-main .dialogue-service-text {
  border: 1px solid #000;
  margin-left: 5px;
  height: 50%;
}

.dialogue-wrapper .dialogue-main .dialogue-hotel-text {
  border: 1px solid white;
  margin-left: 5px;
  width: 100%;
  display: inline-block;
  position: relative;
  padding: 10px;
  white-space: pre-wrap;
  border-radius: 4px;
  color: black;
  /*width: 100%;*/
  background-color: white;
  box-sizing: border-box;
}

.dialogue-wrapper .dialogue-main .dialogue-hotel-text:before {
  content: '';
  position: absolute;
  top: 50%;
  left: -10px;
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  /*border-right: 10px solid #09d07d;*/
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
}

.dialogue-wrapper .dialogue-main .dialogue-service-text:before {
  content: '';
  position: absolute;
  top: 50%;
  left: -10px;
  width: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  /*border-right: 10px solid #09d07d;*/
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
}

.dialogue-wrapper .dialogue-main .dialogue-customer-contain {
  display: flex;
  flex-direction: row-reverse;
  vertical-align: center;
  align-items: center;
  align-content: center;
  margin-top: 10PX;

  /*margin-bottom: 10px;*/
  text-align: left;
}

.dialogue-wrapper .dialogue-main .dialogue-customer-text {
  margin-right: 10px;
  height: 50%;
}

.dialogue-wrapper .dialogue-main .dialogue-customer-text:after {
  content: '';
  position: absolute;
  top: 50%;
  right: -10px;
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  /*border-left: 10px solid #09d07d;*/
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
}

/*客服对话框底部与输入*/
.dialogue-wrapper .dialogue-main .dialogue-submit {
  position: relative;
  padding: 10px;
  height: 100px;
  color: #000;
  word-wrap: break-word;
  border-top: 1px solid #ddd;
  box-sizing: border-box;
}

/*空输入提示*/
.dialogue-wrapper .dialogue-main .dialogue-hint {
  position: absolute;
  top: -15px;
  left: 20px;
  padding: 2px;
  width: 140px;
  height: 18px;
  opacity: 0;
  font-size: 12px;
  text-align: center;
  line-height: 18px;
  border: 1px solid #ddd;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, .4);
  background-color: #fff;
}

.dialogue-wrapper .dialogue-main .dialogue-hint-icon {
  display: inline-block;
  width: 18px;
  height: 18px;
  margin-right: 5px;
  font-size: 14px;
  font-style: italic;
  font-weight: 700;
  vertical-align: middle;
  line-height: 18px;
  color: #fff;
  border-radius: 50%;
  background-color: #302C40
}

.dialogue-wrapper .dialogue-main .dialogue-hint-text {
  display: inline-block;
  vertical-align: middle;
}

/*输入框*/
.dialogue-wrapper .dialogue-submit .dialogue-input-text {
  overflow-y: auto;
  display: inline-block;
  padding: 5px 10px;
  width: 295px;
  height: 70px;
  vertical-align: middle;
  white-space: pre-wrap;
  word-wrap: break-word;
  resize: none;
  border-right: 1px solid #ddd;
  box-sizing: border-box;
}

.dialogue-wrapper .dialogue-submit .dialogue-input-tools {
  display: inline-block;
  width: 80px;
  height: 80px;
  vertical-align: middle;
}

#moreModal {
  border-radius: 100%;
}

@keyframes light {
  from {
    box-shadow: 0 0 4px #1f8cfa;
  }
  to {
    box-shadow: 0 0 20px #1f8cfa;
  }
}

#moreModal.active:before {
  outline: none;
}

.img {
  width: 100px;
  height: 100px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  width: 50px;
  text-align: center;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  font-size: 20px;
  text-align: center;
}

.el-input-group__append {
  background-color: #8ECF56 !important;
}

.el-tooltip__popper.is-light {
  border: solid 1px white !important;
  background-color: white;
}
</style>
<style>
.el-tooltip__popper.is-light {
  border: solid 1px white !important;
  background-color: white;
  margin-right: 10px
}
.chat-hotel-name :hover{
  cursor: pointer;
}
</style>
